module.exports = __webpack_public_path__ + "media/img/home/animate/item1-438cccbdc92dd0e4e4657a982d5ec9f8.svg";